var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPlayerB1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 145,
    viewBox: "0 0 100 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 22H48.4444L53.3333 23.337L57.3333 26.4565L60.4444 32.6957L62.6667 39.8261V48.2935L60.4444 50.0761V54.5326L62.6667 58.5435H67.1111L85.7778 66.1196L92.4444 74.587L96 85.7283L95.1111 96.8696L94.2222 98.6522L93.7778 118.261L96 145H31.5556L28 99.9891L24 92.413L22.2222 86.6196L15.1111 77.2609L0 63V44.5L20.4444 54.9783L35.5556 56.7609L39.5556 59.8804H40.4444L36 55.8696L34.6667 53.1957L32.8889 46.9565L32.4444 45.6196H28.4444L28 42.9457L30.2222 40.2717L29.3333 38.0435V33.587L30.2222 29.1304L34.6667 24.2283L41.3333 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPlayerB1);
export default __webpack_public_path__ + "static/media/bg_player_b1.7c1e2c496e61972b34ffea853ad9ce50.svg";
export { ForwardRef as ReactComponent };